export default __webpack_public_path__ + "static/free_materials-0e1d4e4a9b16aeaf55bc2e13acf42c25.jpeg";